import React from "react";
import {useTranslation} from "react-i18next";
import {useCompetitionSelection} from "utils/hooks/useCompetitionSelection";
import {translatedText} from "pages/Front/Booking/Competitions/competitionUtils";
import CompetitionItemCard from "pages/Front/Booking/Competitions/components/CompetitionItemCard";
import CompetitionActionButton from "pages/Front/Booking/Competitions/components/CompetitionActionButton";
import CompetitionPrice from "pages/Front/Booking/Competitions/components/CompetitionPrice";
import {GroupedCompetitionItem} from "types/entities/GroupedPackageItem";
import useNavigation from "utils/hooks/useNavigation";
import FeatherIcon from "components/FeatherIcon";

interface CompetitionWithoutOptionsProps {
    competition: GroupedCompetitionItem;
}

const CompetitionWithoutOptions = (props: CompetitionWithoutOptionsProps) => {
    const {t} = useTranslation();
    const {handleRouteNavigation} = useNavigation();
    const competition = props.competition.items[0];
    console.log(props.competition);
    const {
        isFreeSelect,
        isFree,
        isSelected,
        isDisabled,
        needsCredit,
        totalSelectedCreditsValue,
        totalSelectedCreditsQuantity,
        isFamilyCategory,
        hasEnoughCredits,
        toggleCompetition,
    } = useCompetitionSelection(competition);

    const infoText =
        needsCredit && !hasEnoughCredits
            ? isFamilyCategory
                ? t("Needs at least {{amount}} credits - currently {{current}}", {
                      amount: competition.competition?.needs_credit_amount,
                      current: totalSelectedCreditsValue,
                  })
                : t("Needs at least {{amount}} persons with credits - currently {{current}}", {
                      amount: competition.minimum_persons_count,
                      current: totalSelectedCreditsQuantity,
                  })
            : undefined;

    const action =
        needsCredit && !hasEnoughCredits ? (
            <button
                className={
                    "CompetitionActionButton min-h-[32px] w-full xs:w-auto min-w-[120px] flex flex-row items-center justify-center gap-x-1.5 shrink-0 rounded border border-black bg-white px-2 py-1 text-xs font-bold text-black leading-none hover:bg-gray-50"
                }
                type={"button"}
                onClick={handleRouteNavigation}
            >
                <FeatherIcon className={"size-[22px] flex-none"} name={"arrow-left"} />
                <span className={"whitespace-nowrap"}>{t("Add credits")}</span>
            </button>
        ) : (
            <CompetitionActionButton
                className={"w-full xs:w-auto"}
                disabled={isDisabled}
                isFreeSelect={isFreeSelect}
                isSelected={isSelected}
                onClick={toggleCompetition}
            />
        );

    return (
        <div className={"CompetitionWithoutOptions w-full"}>
            <CompetitionItemCard
                action={action}
                categoryType={props.competition.competition?.category_type}
                description={translatedText(props.competition.description)}
                descriptionHtml={translatedText(props.competition.description_html)}
                image={props.competition.image}
                infoText={infoText}
                isSelected={isSelected}
                price={isFree ? null : <CompetitionPrice competition={competition} />}
                title={translatedText(props.competition.name)}
            />
        </div>
    );
};

export default CompetitionWithoutOptions;
